import React from 'react';

import bgCardNoise from '../../../main/assets/images/skydive/cards-noise-effect.png';

export const Cards = () => {
  return (
    <div className="skydive-cards-section">
      <div className="skydive-cards-card">
        <img
          src={bgCardNoise}
          alt="Noise Background Effect for the First Card"
          className="skydive-cards-card-noise"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="85"
          height="84"
          viewBox="0 0 85 84"
          fill="none"
          className="skydive-cards-card-icon"
        >
          <g>
            <path
              d="M42.5007 0.333252C47.9724 0.333252 53.3906 1.41099 58.4458 3.50494C63.501 5.59888 68.0943 8.66803 71.9634 12.5371C75.8326 16.4062 78.9017 20.9995 80.9956 26.0548C83.0896 31.11 84.1673 36.5282 84.1673 41.9999C84.1673 53.0506 79.7775 63.6487 71.9634 71.4627C64.1494 79.2767 53.5513 83.6666 42.5007 83.6666C23.334 83.6666 7.29232 70.8333 2.33398 53.3749L18.2923 59.9583C18.8391 62.6273 20.2902 65.0259 22.4005 66.7491C24.5109 68.4723 27.1512 69.4145 29.8757 69.4166C36.3757 69.4166 41.6673 64.1249 41.6673 57.6249V57.0833L55.834 46.9583H56.1673C64.834 46.9583 71.8757 39.9166 71.8757 31.2499C71.8757 22.5833 64.834 15.5416 56.1673 15.5416C47.5007 15.5416 40.4173 22.5833 40.4173 31.2499V31.4583L30.5423 45.8749L29.8757 45.8333C27.4173 45.8333 25.1257 46.5833 23.2507 47.8749L0.833984 38.6666C2.62565 17.2083 20.5423 0.333252 42.5007 0.333252ZM27.0007 63.5416C30.334 64.9166 34.1673 63.3749 35.5423 60.0416C36.9173 56.7083 35.334 52.9166 32.084 51.5416L26.7507 49.3333C28.7923 48.5833 31.084 48.5416 33.2507 49.4583C35.459 50.3333 37.1673 52.0416 38.0423 54.2499C38.959 56.4166 38.959 58.8333 38.0423 60.9999C36.2507 65.4999 30.959 67.6666 26.459 65.7916C24.3757 64.9166 22.7923 63.3333 21.9173 61.4583L27.0007 63.5416ZM66.6673 31.2499C66.6673 37.0416 61.959 41.7499 56.1673 41.7499C53.3898 41.7389 50.7298 40.6278 48.7696 38.6598C46.8095 36.6919 45.709 34.0275 45.709 31.2499C45.7035 29.875 45.9702 28.5125 46.4939 27.2412C47.0175 25.9698 47.7876 24.8147 48.7599 23.8425C49.7321 22.8702 50.8872 22.1001 52.1586 21.5765C53.4299 21.0528 54.7924 20.7861 56.1673 20.7916C58.9449 20.7916 61.6093 21.8921 63.5772 23.8522C65.5452 25.8123 66.6563 28.4724 66.6673 31.2499ZM48.334 31.2499C48.334 35.5833 51.834 39.1249 56.209 39.1249C60.5423 39.1249 64.0423 35.5833 64.0423 31.2499C64.0423 26.9166 60.5423 23.3749 56.209 23.3749C51.834 23.3749 48.334 26.9166 48.334 31.2499Z"
              fill="white"
              fillOpacity="0.4"
            />
          </g>
        </svg>

        <div className="skydive-cards-card-content">
          <div className="skydive-cards-card-text">
            <h2 className="skydive-cards-card-title">Steam</h2>
            <p className="skydive-cards-card-description">
              Join over 1 million pilots and start your FPV journey for free -
              now available on Steam for Windows, Mac, Linux, and Steam Deck.
              Download FPV SkyDive today!
            </p>
          </div>
          <a
            className="skydive-cards-cta-container"
            target="_blank"
            href="https://store.steampowered.com/app/1278060/FPV_SkyDive__FPV_Drone_Simulator/"
            rel="noopener noreferrer nofollow"
            onMouseDown={event => event.preventDefault()}
          >
            <div className="skydive-cards-card-cta">
              <p className="skydive-cards-cta-text">Download for free</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.7587 16.315C16.7963 16.406 16.8518 16.4887 16.9218 16.558C16.9912 16.628 17.0738 16.6835 17.1649 16.7211C17.2559 16.7588 17.3536 16.7778 17.4521 16.7772C17.6509 16.7771 17.8415 16.6981 17.982 16.5575C18.1225 16.417 18.2015 16.2264 18.2017 16.0277V7.5424C18.2015 7.34365 18.1225 7.15307 17.982 7.01253C17.8415 6.872 17.6509 6.79299 17.4521 6.79286L8.96685 6.79286C8.77264 6.79972 8.58867 6.88169 8.45371 7.02151C8.31874 7.16132 8.24331 7.34807 8.24331 7.5424C8.24331 7.73673 8.31874 7.92347 8.45371 8.06329C8.58867 8.20311 8.77264 8.28508 8.96685 8.29193L15.6421 8.29193L7.02095 16.9131C6.88269 17.055 6.80533 17.2453 6.80533 17.4434C6.80533 17.6415 6.88269 17.8318 7.02095 17.9737C7.16286 18.112 7.35315 18.1894 7.55128 18.1894C7.7494 18.1894 7.93969 18.112 8.08161 17.9737L16.7026 9.35275L16.7026 16.0277C16.702 16.1262 16.7211 16.2239 16.7587 16.315Z"
                  fill="white"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
      <div className="skydive-cards-card">
        <img
          src={bgCardNoise}
          alt="Noise Background Effect for the Second Card"
          className="skydive-cards-card-noise"
        />
        <div className="sykdive-cards-card-icons">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="101"
            height="100"
            viewBox="0 0 101 100"
            fill="none"
            className="skydive-cards-card-icon"
          >
            <g clipPath="url(#clip0_1126_6415)">
              <g>
                <path
                  d="M22.9743 84.5792L20.466 88.5042C19.6093 89.9598 18.2132 91.019 16.5806 91.4519C14.948 91.8848 13.2106 91.6566 11.7452 90.8167C11.0214 90.4061 10.3862 89.856 9.87651 89.1983C9.36676 88.5406 8.99255 87.7883 8.77554 86.985C8.55853 86.1816 8.50303 85.3432 8.61225 84.5183C8.72148 83.6934 8.99325 82.8983 9.41185 82.1792L10.9993 79.8542C11.6118 78.9875 13.116 77.4875 16.1243 77.7708C16.1243 77.7708 23.2077 78.5333 23.7202 82.1792C23.7202 82.1792 23.791 83.3792 22.9743 84.5792ZM93.7827 59.0458H78.7202C77.6952 58.9792 77.2494 58.6167 77.0702 58.4042L77.0618 58.3833L62.666 35.05C61.0827 32.65 58.566 38.7875 58.566 38.7875C55.5618 45.6292 58.991 53.4083 60.191 55.7583L79.866 88.4958C80.7227 89.9515 82.1188 91.0106 83.7514 91.4436C85.384 91.8765 87.1215 91.6482 88.5868 90.8083C89.3106 90.3978 89.9458 89.8477 90.4555 89.19C90.9653 88.5323 91.3395 87.78 91.5565 86.9766C91.7735 86.1733 91.829 85.3349 91.7198 84.51C91.6105 83.6851 91.3388 82.89 90.9202 82.1708L85.3243 72.5625C85.216 72.3292 85.0243 71.7 86.1743 71.6958H93.7827C97.3077 71.6958 100.166 68.8625 100.166 65.3708C100.166 61.8792 97.3077 59.0458 93.7827 59.0458ZM57.516 67.6458C57.516 67.6458 58.3202 71.6958 55.2077 71.6958H6.54935C3.02435 71.6958 0.166016 68.8625 0.166016 65.3708C0.166016 61.8792 3.02435 59.0458 6.54935 59.0458H20.8618C23.1743 58.9125 23.7202 57.5917 23.7202 57.5917L23.7327 57.6L42.416 25.5417C42.5198 25.3407 42.5739 25.1178 42.5739 24.8917C42.5739 24.6655 42.5198 24.4426 42.416 24.2417L36.2493 13.6542C35.8308 12.935 35.559 12.1399 35.4498 11.315C35.3405 10.4901 35.396 9.65169 35.613 8.84836C35.8301 8.04504 36.2043 7.29274 36.714 6.63502C37.2237 5.9773 37.8589 5.42724 38.5827 5.01667C40.0485 4.17546 41.7869 3.94648 43.4205 4.37946C45.0541 4.81243 46.451 5.8724 47.3077 7.32917L50.166 12.2417L53.0202 7.3375C53.8769 5.88186 55.2729 4.82269 56.9056 4.38977C58.5382 3.95686 60.2756 4.1851 61.741 5.025C62.4651 5.43522 63.1007 5.98503 63.6109 6.64259C64.121 7.30015 64.4956 8.05239 64.7131 8.85574C64.9305 9.6591 64.9863 10.4976 64.8774 11.3227C64.7685 12.1478 64.4969 12.9431 64.0785 13.6625L38.0827 58.275C37.9702 58.5458 37.9368 58.9708 38.7827 59.0458H47.3077C47.3077 59.0458 56.291 59.3375 57.516 67.6458Z"
                  fill="white"
                  fillOpacity="0.4"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_1126_6415">
                <rect
                  width="100"
                  height="100"
                  fill="white"
                  transform="translate(0.166016)"
                />
              </clipPath>
            </defs>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="95"
            height="94"
            viewBox="0 0 95 94"
            fill="none"
            className="skydive-cards-card-icon"
          >
            <g>
              <path
                d="M15.3202 13.4498L51.7369 47.0195L15.5911 80.8987C14.9997 80.1748 14.5406 79.3634 14.2327 78.4978C14.0735 77.5177 14.0735 76.5207 14.2327 75.5407V17.8873C14.1244 16.3403 14.5036 14.7932 15.3161 13.4498M67.4244 32.379L55.5369 43.4475L19.5536 10.1833C20.7202 9.80334 21.9702 9.69759 23.1911 9.87775C25.1077 10.3713 26.9369 11.1311 28.6161 12.122L61.1827 29.0616C63.2994 30.1308 65.3619 31.2549 67.4244 32.379ZM55.5411 50.6424L67.3702 61.5621L58.7952 66.0506L32.6327 79.7198C30.4661 80.8438 28.2911 81.917 26.1744 83.1429C25.2687 83.673 24.2531 84.0153 23.1954 84.147C22.1377 84.2787 21.0624 84.1968 20.0411 83.9067L55.5411 50.6424ZM86.2077 47.0195C86.2381 48.3891 85.8699 49.7404 85.143 50.9277C84.416 52.1149 83.3578 53.0929 82.0827 53.7562L72.3077 58.8557L59.4452 47.0195L72.3619 34.9797C75.6744 36.7148 78.9327 38.4498 82.1869 40.0831C83.4847 40.7649 84.5507 41.7782 85.2615 43.0057C85.9723 44.2332 86.3031 45.6248 86.2077 47.0195Z"
                fill="white"
                fillOpacity="0.4"
              />
            </g>
          </svg>
        </div>
        <div className="skydive-cards-card-content">
          <div className="skydive-cards-card-text">
            <h2 className="skydive-cards-card-title">stores</h2>
            <p className="skydive-cards-card-description">
              Experience the true FPV simulator on mobile! Take your flying
              skills to new heights, now available on the App Store and Google
              Play.
            </p>
          </div>
          <div className="skydive-cards-card-links">
            <a
              className="skydive-cards-cta-container"
              target="_blank"
              href="https://apps.apple.com/us/app/orqa-fpv-skydive/id1577007626"
              rel="noopener noreferrer nofollow"
              onMouseDown={event => event.preventDefault()}
            >
              <div className="skydive-cards-card-cta">
                <p className="skydive-cards-cta-text">App Store</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7587 16.315C16.7963 16.406 16.8518 16.4887 16.9218 16.558C16.9912 16.628 17.0738 16.6835 17.1649 16.7211C17.2559 16.7588 17.3536 16.7778 17.4521 16.7772C17.6509 16.7771 17.8415 16.6981 17.982 16.5575C18.1225 16.417 18.2015 16.2264 18.2017 16.0277V7.5424C18.2015 7.34365 18.1225 7.15307 17.982 7.01253C17.8415 6.872 17.6509 6.79299 17.4521 6.79286L8.96685 6.79286C8.77264 6.79972 8.58867 6.88169 8.45371 7.02151C8.31874 7.16132 8.24331 7.34807 8.24331 7.5424C8.24331 7.73673 8.31874 7.92347 8.45371 8.06329C8.58867 8.20311 8.77264 8.28508 8.96685 8.29193L15.6421 8.29193L7.02095 16.9131C6.88269 17.055 6.80533 17.2453 6.80533 17.4434C6.80533 17.6415 6.88269 17.8318 7.02095 17.9737C7.16286 18.112 7.35315 18.1894 7.55128 18.1894C7.7494 18.1894 7.93969 18.112 8.08161 17.9737L16.7026 9.35275L16.7026 16.0277C16.702 16.1262 16.7211 16.2239 16.7587 16.315Z"
                    fill="white"
                  />
                </svg>
              </div>
            </a>
            <a
              className="skydive-cards-cta-container"
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.Orqa.FPVSkyDive&hl=en"
              rel="noopener noreferrer nofollow"
              onMouseDown={event => event.preventDefault()}
            >
              <div className="skydive-cards-card-cta">
                <p className="skydive-cards-cta-text">Google Play</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7587 16.315C16.7963 16.406 16.8518 16.4887 16.9218 16.558C16.9912 16.628 17.0738 16.6835 17.1649 16.7211C17.2559 16.7588 17.3536 16.7778 17.4521 16.7772C17.6509 16.7771 17.8415 16.6981 17.982 16.5575C18.1225 16.417 18.2015 16.2264 18.2017 16.0277V7.5424C18.2015 7.34365 18.1225 7.15307 17.982 7.01253C17.8415 6.872 17.6509 6.79299 17.4521 6.79286L8.96685 6.79286C8.77264 6.79972 8.58867 6.88169 8.45371 7.02151C8.31874 7.16132 8.24331 7.34807 8.24331 7.5424C8.24331 7.73673 8.31874 7.92347 8.45371 8.06329C8.58867 8.20311 8.77264 8.28508 8.96685 8.29193L15.6421 8.29193L7.02095 16.9131C6.88269 17.055 6.80533 17.2453 6.80533 17.4434C6.80533 17.6415 6.88269 17.8318 7.02095 17.9737C7.16286 18.112 7.35315 18.1894 7.55128 18.1894C7.7494 18.1894 7.93969 18.112 8.08161 17.9737L16.7026 9.35275L16.7026 16.0277C16.702 16.1262 16.7211 16.2239 16.7587 16.315Z"
                    fill="white"
                  />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="skydive-cards-card">
        <img
          src={bgCardNoise}
          alt="Noise Background Effect for the Third Card"
          className="skydive-cards-card-noise"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="101"
          height="100"
          viewBox="0 0 101 100"
          fill="none"
          className="skydive-cards-card-icon"
        >
          <g>
            <path
              d="M81.1258 22.2084C75.5841 19.6251 69.5841 17.7501 63.3341 16.6667C63.2242 16.6683 63.1194 16.7132 63.0425 16.7917C62.2925 18.1667 61.4175 19.9584 60.8341 21.3334C54.2049 20.334 47.4634 20.334 40.8341 21.3334C40.2508 19.9167 39.3758 18.1667 38.5841 16.7917C38.5425 16.7084 38.4175 16.6667 38.2925 16.6667C32.0425 17.7501 26.0841 19.6251 20.5008 22.2084C20.4591 22.2084 20.4175 22.2501 20.3758 22.2917C9.04248 39.2501 5.91748 55.7501 7.45915 72.0834C7.45915 72.1667 7.50081 72.2501 7.58415 72.2917C15.0841 77.7917 22.2925 81.1251 29.4175 83.3334C29.5425 83.3751 29.6675 83.3334 29.7091 83.2501C31.3758 80.9584 32.8758 78.5417 34.1675 76.0001C34.2508 75.8334 34.1675 75.6667 34.0008 75.6251C31.6258 74.7084 29.3758 73.6251 27.1675 72.3751C27.0008 72.2917 27.0008 72.0417 27.1258 71.9167C27.5841 71.5834 28.0425 71.2084 28.5008 70.8751C28.5841 70.7917 28.7091 70.7917 28.7925 70.8334C43.1258 77.3751 58.5841 77.3751 72.7508 70.8334C72.8341 70.7917 72.9591 70.7917 73.0425 70.8751C73.5008 71.2501 73.9591 71.5834 74.4175 71.9584C74.5841 72.0834 74.5841 72.3334 74.3758 72.4167C72.2091 73.7084 69.9175 74.7501 67.5425 75.6667C67.3758 75.7084 67.3341 75.9167 67.3758 76.0417C68.7091 78.5834 70.2091 81.0001 71.8342 83.2917C71.9592 83.3334 72.0841 83.3751 72.2091 83.3334C79.3758 81.1251 86.5841 77.7917 94.0841 72.2917C94.1675 72.2501 94.2091 72.1667 94.2091 72.0834C96.0425 53.2084 91.1675 36.8334 81.2925 22.2917C81.2508 22.2501 81.2091 22.2084 81.1258 22.2084ZM36.3341 62.1251C32.0425 62.1251 28.4591 58.1667 28.4591 53.2917C28.4591 48.4167 31.9591 44.4584 36.3341 44.4584C40.7508 44.4584 44.2508 48.4584 44.2091 53.2917C44.2091 58.1667 40.7091 62.1251 36.3341 62.1251ZM65.3758 62.1251C61.0841 62.1251 57.5008 58.1667 57.5008 53.2917C57.5008 48.4167 61.0008 44.4584 65.3758 44.4584C69.7925 44.4584 73.2925 48.4584 73.2508 53.2917C73.2508 58.1667 69.7925 62.1251 65.3758 62.1251Z"
              fill="white"
              fillOpacity="0.4"
            />
          </g>
        </svg>
        <div className="skydive-cards-card-content">
          <div className="skydive-cards-card-text">
            <h2 className="skydive-cards-card-title">discord</h2>
            <p className="skydive-cards-card-description">
              One of the largest FPV communities in the world, with more than
              5,000 members on Discord! Enjoy active discussions, giveaways, and
              exclusive access to beta testing!
            </p>
          </div>
          <a
            className="skydive-cards-cta-container"
            target="_blank"
            href="https://discord.com/invite/g5dvZS6neu"
            rel="noopener noreferrer nofollow"
            onMouseDown={event => event.preventDefault()}
          >
            <div className="skydive-cards-card-cta">
              <p className="skydive-cards-cta-text">Join us</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.7587 16.315C16.7963 16.406 16.8518 16.4887 16.9218 16.558C16.9912 16.628 17.0738 16.6835 17.1649 16.7211C17.2559 16.7588 17.3536 16.7778 17.4521 16.7772C17.6509 16.7771 17.8415 16.6981 17.982 16.5575C18.1225 16.417 18.2015 16.2264 18.2017 16.0277V7.5424C18.2015 7.34365 18.1225 7.15307 17.982 7.01253C17.8415 6.872 17.6509 6.79299 17.4521 6.79286L8.96685 6.79286C8.77264 6.79972 8.58867 6.88169 8.45371 7.02151C8.31874 7.16132 8.24331 7.34807 8.24331 7.5424C8.24331 7.73673 8.31874 7.92347 8.45371 8.06329C8.58867 8.20311 8.77264 8.28508 8.96685 8.29193L15.6421 8.29193L7.02095 16.9131C6.88269 17.055 6.80533 17.2453 6.80533 17.4434C6.80533 17.6415 6.88269 17.8318 7.02095 17.9737C7.16286 18.112 7.35315 18.1894 7.55128 18.1894C7.7494 18.1894 7.93969 18.112 8.08161 17.9737L16.7026 9.35275L16.7026 16.0277C16.702 16.1262 16.7211 16.2239 16.7587 16.315Z"
                  fill="white"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
